export enum CompareResult {
  aIsLarger = 1,
  bIsLarger = -1,
  equal = 0
}

/** Compares two version and returns which one is larger. */
export function compareDesignVersions(
  versionA: string,
  versionB: string
): CompareResult {
  if (versionA === versionB) {
    return CompareResult.equal;
  }

  const splitA = versionA.split('.');
  const splitB = versionB.split('.');

  for (let i = 0; i < splitA.length || i < splitB.length; ++i) {
    const aNumber = parseInt(splitA[i]);
    const bNumber = parseInt(splitB[i]);

    if (
      aNumber > bNumber
      || (!isNaN(aNumber) && isNaN(bNumber))
    ) {
      return CompareResult.aIsLarger;
    } else if (
      bNumber > aNumber
      || (!isNaN(bNumber) && isNaN(aNumber))
    ) {
      return CompareResult.bIsLarger;
    }
  }

  return CompareResult.equal;
}
